import { CURR_ENV } from '@/core/constants/appConfig/environment';
import { EBundleName } from '@/sources';

import { initSourceEntryPoint } from '../init_entrypoint';
import { ShopifySourceBundle } from './bundle';

(() => {
  // Initialize the Logger and Data Layer
  const wtagFunctionKey: string = initSourceEntryPoint(
    EBundleName.SHOPIFY_DEFAULT,
  );

  // window[`wgs_${CURR_ENV}_script`] = [new URL(import.meta.url).href];
  const env = CURR_ENV;
  (window as any)[`wgs_${env}_script`] =
    document.currentScript?.getAttribute('src');

  // Initialize the Shopify source bundle
  const shopifySourceBundle: ShopifySourceBundle = new ShopifySourceBundle(
    {},
    (window as any)[wtagFunctionKey],
  );
  shopifySourceBundle.init();
})();
